import { CalendarDaysIcon } from 'components/icons';
import React from 'react';

export function JobsiteScheduleEmptyState({
  message,
}: {
  message: string;
}): React.ReactElement {
  return (
    <div className="odin-flex odin-flex-col odin-gap-4 odin-items-center odin-py-8">
      <CalendarDaysIcon className="odin-text-6xl odin-text-gray-500" />
      <p className="odin-text-lg">{message}</p>
    </div>
  );
}
